import RelationsEditable from 'components/RelationsEditable';
import RelationsTable from 'components/RelationsTable';
import useEntities from 'hooks/useEntities';
import useLoginStore from 'store/loginStore';

const PlayerTeams = ({ sourceEntityId, sourceEntityData, data, onChange }) => {
    const entities = useEntities();
    const isPlayer = useLoginStore(s => s.isPlayer)();

    // For players, disable all write operations and links - use RelationsTable (read-only)
    if (isPlayer) {
        // Replace NameWithLogoClickable with NameWithLogo (without link) for players
        // Hide ExternalId for players
        const playerColumns = entities.Team.defaultColumnsForRelations?.map(colName => {
            if (colName === 'NameWithLogoClickable') {
                return 'NameWithLogo'; // Use non-clickable version for players
            }
            return colName;
        }).filter(colName => colName != 'externalId') || ['NameWithLogo'];
        
        return (
            <RelationsTable
                data={data}
                sourceEntity={entities.Player}
                targetEntity={entities.Team}
                emptyMessage="This player does not belong to any teams"
                sourceEntityId={sourceEntityId}
                rowClickable={false}
                columns={playerColumns}
            />
        )
    }
    
    return (
        <RelationsEditable
            data={data}
            sourceEntity={entities.Player}
            targetEntity={entities.Team}
            emptyMessage="This player does not belong to any teams"
            sourceEntityId={sourceEntityId}
            onChange={onChange}
            addButtonText="Add Team"
            // canRemove={isAdmin || (sourceEntityData?.status == 'DRAFT' && data?.length > 1)}
            cannotRemoveTooltip={
                sourceEntityData?.status != 'DRAFT'
                    ?
                        "Please use the 'Request Change' button to request removal of this Player from this Team."
                    :
                        data?.length <= 1
                            ?
                                "A Player belong to at least one Team."
                            :
                                null
            }
            // canAdd={isAdmin || sourceEntityData?.status == 'DRAFT'}
        />
    )
}

export default PlayerTeams
